import { Component, OnInit } from '@angular/core';
import { DokItemInfo } from '@app/components/dokumentacija/dokumentacija-types';
import {
  FQAN_razina,
  Razina
} from '@app/components/hierarhija/hierarhija.component';
import {
  ActionComponent,
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { map, tap } from 'rxjs';
import { PremjestiDokJedinicuService } from '../premjesti-dok-jedinicu-action/premjesti-dok-jedinicu.service';

@Component({
  selector: 'app-kopiraj-dokument-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class KopirajDokumentActionComponent
  extends ActionComponent
  implements OnInit
{
  private selectedItem: any;

  constructor(
    protected listViewProvider: ListViewProviderDirective<ListView>,
    protected premjestiDokJedinicuService: PremjestiDokJedinicuService,
    protected notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.listViewProvider.selectedItems$
        .pipe(
          tap((selected) => {
            if (!!selected && selected.length == 1) {
              this.selectedItem = selected[0];
            }
          })
        )
        .subscribe()
    );
  }

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems: any[]) => {
        return this.isDisabled(selectedItems);
      })
    );
  }

  private isDisabled(selectedItems: any[]): boolean {
    const singleItemSelected = selectedItems && selectedItems.length === 1;
    const item = singleItemSelected ? selectedItems[0] : null;
    const dokInfo = item ? new DokItemInfo(item) : null;
    return (
      !dokInfo || dokInfo.permission < 2 || Razina.DOKUMENT > item[FQAN_razina]
    );
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  override executeAction(event: any): void {
    this.premjestiDokJedinicuService.copyJedinica(this.selectedItem);
  }
}
